import state from './moduleCrewListState.js'
import mutations from './moduleCrewListMutations.js'
import actions from './moduleCrewListActions.js'
import getters from './moduleCrewListGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
